<template>
  <v-select
    :items="contractTypeList"
    item-value="id"
    item-text="name"
    v-model="idValue"
    label="Contract Type"
    :readonly="readonly"
    :rules="[requiredCheck()]"
    outlined
    :dense="dense ? dense : false"
  ></v-select>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'id',
    'isRequired',
    'readonly',
    'dense'
  ],
  computed: {
    ...mapFields('contractTypes', [
      'contractTypeList'
    ]),
    idValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('change', newValue)
      }
    }
  },
  methods: {
    ...mapActions('contractTypes', [
      'getContractTypes'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Contract Type')
    }
  },
  created () {
    this.getContractTypes()
  }
}
</script>
